import billingEn from './locales/en/billing.json' with { type: 'json' }
import authEn from './locales/en/auth.json' with { type: 'json' }
import actionsEn from './locales/en/actions.json' with { type: 'json' }
import commonEn from './locales/en/common.json' with { type: 'json' }
import corporateEn from './locales/en/corporate.json' with { type: 'json' }
import errorsEn from './locales/en/errors.json' with { type: 'json' }
import notificationsEn from './locales/en/notifications.json' with { type: 'json' }
import paymentEn from './locales/en/payment.json' with { type: 'json' }
import posterEn from './locales/en/poster.json' with { type: 'json' }
import storageEn from './locales/en/storage.json' with { type: 'json' }
import timeEn from './locales/en/time.json' with { type: 'json' }
import billingZh from './locales/zh/billing.json' with { type: 'json' }
import authZh from './locales/zh/auth.json' with { type: 'json' }
import actionsZh from './locales/zh/actions.json' with { type: 'json' }
import commonZh from './locales/zh/common.json' with { type: 'json' }
import corporateZh from './locales/zh/corporate.json' with { type: 'json' }
import errorsZh from './locales/zh/errors.json' with { type: 'json' }
import notificationsZh from './locales/zh/notifications.json' with { type: 'json' }
import paymentZh from './locales/zh/payment.json' with { type: 'json' }
import posterZh from './locales/zh/poster.json' with { type: 'json' }
import storageZh from './locales/zh/storage.json' with { type: 'json' }
import timeZh from './locales/zh/time.json' with { type: 'json' }
import billingJa from './locales/ja/billing.json' with { type: 'json' }
import authJa from './locales/ja/auth.json' with { type: 'json' }
import actionsJa from './locales/ja/actions.json' with { type: 'json' }
import commonJa from './locales/ja/common.json' with { type: 'json' }
import corporateJa from './locales/ja/corporate.json' with { type: 'json' }
import errorsJa from './locales/ja/errors.json' with { type: 'json' }
import notificationsJa from './locales/ja/notifications.json' with { type: 'json' }
import paymentJa from './locales/ja/payment.json' with { type: 'json' }
import posterJa from './locales/ja/poster.json' with { type: 'json' }
import storageJa from './locales/ja/storage.json' with { type: 'json' }
import timeJa from './locales/ja/time.json' with { type: 'json' }
import billingKo from './locales/ko/billing.json' with { type: 'json' }
import authKo from './locales/ko/auth.json' with { type: 'json' }
import actionsKo from './locales/ko/actions.json' with { type: 'json' }
import commonKo from './locales/ko/common.json' with { type: 'json' }
import corporateKo from './locales/ko/corporate.json' with { type: 'json' }
import errorsKo from './locales/ko/errors.json' with { type: 'json' }
import notificationsKo from './locales/ko/notifications.json' with { type: 'json' }
import paymentKo from './locales/ko/payment.json' with { type: 'json' }
import posterKo from './locales/ko/poster.json' with { type: 'json' }
import storageKo from './locales/ko/storage.json' with { type: 'json' }
import timeKo from './locales/ko/time.json' with { type: 'json' }
import billingFr from './locales/fr/billing.json' with { type: 'json' }
import authFr from './locales/fr/auth.json' with { type: 'json' }
import actionsFr from './locales/fr/actions.json' with { type: 'json' }
import commonFr from './locales/fr/common.json' with { type: 'json' }
import corporateFr from './locales/fr/corporate.json' with { type: 'json' }
import errorsFr from './locales/fr/errors.json' with { type: 'json' }
import notificationsFr from './locales/fr/notifications.json' with { type: 'json' }
import paymentFr from './locales/fr/payment.json' with { type: 'json' }
import posterFr from './locales/fr/poster.json' with { type: 'json' }
import storageFr from './locales/fr/storage.json' with { type: 'json' }
import timeFr from './locales/fr/time.json' with { type: 'json' }

export const sharedLanguageCodes = ['en', 'zh', 'ja', 'ko', 'fr'] as const

export type SharedLanguageCode = (typeof sharedLanguageCodes)[number]

type ResourcePrimitive = string

export interface ResourceMap {
  [key: string]: ResourcePrimitive | ResourceMap | Array<ResourcePrimitive | ResourceMap>
}

export type NamespaceResources = Record<string, ResourceMap>
export type TranslationResources = Record<string, { translation: ResourceMap }>

export const sharedNamespaceResources: NamespaceResources = {
  en: { billing: billingEn, auth: authEn, actions: actionsEn, common: commonEn, corporate: corporateEn, errors: errorsEn, notifications: notificationsEn, payment: paymentEn, poster: posterEn, storage: storageEn, time: timeEn },
  zh: { billing: billingZh, auth: authZh, actions: actionsZh, common: commonZh, corporate: corporateZh, errors: errorsZh, notifications: notificationsZh, payment: paymentZh, poster: posterZh, storage: storageZh, time: timeZh },
  ja: { billing: billingJa, auth: authJa, actions: actionsJa, common: commonJa, corporate: corporateJa, errors: errorsJa, notifications: notificationsJa, payment: paymentJa, poster: posterJa, storage: storageJa, time: timeJa },
  ko: { billing: billingKo, auth: authKo, actions: actionsKo, common: commonKo, corporate: corporateKo, errors: errorsKo, notifications: notificationsKo, payment: paymentKo, poster: posterKo, storage: storageKo, time: timeKo },
  fr: { billing: billingFr, auth: authFr, actions: actionsFr, common: commonFr, corporate: corporateFr, errors: errorsFr, notifications: notificationsFr, payment: paymentFr, poster: posterFr, storage: storageFr, time: timeFr },
}

function createFlatTranslationResource(namespace: string, resource: ResourceMap): ResourceMap {
  return {
    [namespace]: resource,
  }
}

function isPlainObject(value: unknown): value is ResourceMap {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function deepMergeObjects(base: ResourceMap, override: ResourceMap): ResourceMap {
  const merged: ResourceMap = { ...base }

  for (const [key, value] of Object.entries(override)) {
    const existing = merged[key]
    if (isPlainObject(existing) && isPlainObject(value)) {
      merged[key] = deepMergeObjects(existing, value)
      continue
    }
    merged[key] = value
  }

  return merged
}

export function mergeNamespaceResources(...resourceSets: NamespaceResources[]): NamespaceResources {
  const merged: NamespaceResources = {}

  for (const resourceSet of resourceSets) {
    for (const [language, namespaces] of Object.entries(resourceSet)) {
      merged[language] ??= {}
      for (const [namespace, resource] of Object.entries(namespaces)) {
        const current = merged[language][namespace]
        if (isPlainObject(current) && isPlainObject(resource)) {
          merged[language][namespace] = deepMergeObjects(current, resource)
          continue
        }
        merged[language][namespace] = resource
      }
    }
  }

  return merged
}

export function flattenNamespaceResources(resources: NamespaceResources): TranslationResources {
  const flattened: TranslationResources = {}

  for (const [language, namespaces] of Object.entries(resources)) {
    let translation: ResourceMap = {}
    for (const resource of Object.values(namespaces)) {
      if (isPlainObject(resource)) {
        translation = deepMergeObjects(translation, resource)
      }
    }
    flattened[language] = { translation }
  }

  return flattened
}

export const sharedTranslationResources: TranslationResources = {
  en: {
    translation: deepMergeObjects(
      deepMergeObjects(
        deepMergeObjects(
          deepMergeObjects(
            billingEn,
            createFlatTranslationResource('auth', authEn)
          ),
          deepMergeObjects(
            createFlatTranslationResource('actions', actionsEn),
            deepMergeObjects(
              createFlatTranslationResource('common', commonEn),
              createFlatTranslationResource('corporate', corporateEn)
            )
          )
        ),
        createFlatTranslationResource('errors', errorsEn)
      ),
      deepMergeObjects(
        deepMergeObjects(
          createFlatTranslationResource('notifications', notificationsEn),
          createFlatTranslationResource('poster', posterEn)
        ),
        deepMergeObjects(
          deepMergeObjects(
            createFlatTranslationResource('payment', paymentEn),
            createFlatTranslationResource('storage', storageEn)
          ),
          createFlatTranslationResource('time', timeEn)
        )
      )
    ),
  },
  zh: {
    translation: deepMergeObjects(
      deepMergeObjects(
        deepMergeObjects(
          deepMergeObjects(
            billingZh,
            createFlatTranslationResource('auth', authZh)
          ),
          deepMergeObjects(
            createFlatTranslationResource('actions', actionsZh),
            deepMergeObjects(
              createFlatTranslationResource('common', commonZh),
              createFlatTranslationResource('corporate', corporateZh)
            )
          )
        ),
        createFlatTranslationResource('errors', errorsZh)
      ),
      deepMergeObjects(
        deepMergeObjects(
          createFlatTranslationResource('notifications', notificationsZh),
          createFlatTranslationResource('poster', posterZh)
        ),
        deepMergeObjects(
          deepMergeObjects(
            createFlatTranslationResource('payment', paymentZh),
            createFlatTranslationResource('storage', storageZh)
          ),
          createFlatTranslationResource('time', timeZh)
        )
      )
    ),
  },
  ja: {
    translation: deepMergeObjects(
      deepMergeObjects(
        deepMergeObjects(
          deepMergeObjects(
            billingJa,
            createFlatTranslationResource('auth', authJa)
          ),
          deepMergeObjects(
            createFlatTranslationResource('actions', actionsJa),
            deepMergeObjects(
              createFlatTranslationResource('common', commonJa),
              createFlatTranslationResource('corporate', corporateJa)
            )
          )
        ),
        createFlatTranslationResource('errors', errorsJa)
      ),
      deepMergeObjects(
        deepMergeObjects(
          createFlatTranslationResource('notifications', notificationsJa),
          createFlatTranslationResource('poster', posterJa)
        ),
        deepMergeObjects(
          deepMergeObjects(
            createFlatTranslationResource('payment', paymentJa),
            createFlatTranslationResource('storage', storageJa)
          ),
          createFlatTranslationResource('time', timeJa)
        )
      )
    ),
  },
  ko: {
    translation: deepMergeObjects(
      deepMergeObjects(
        deepMergeObjects(
          deepMergeObjects(
            billingKo,
            createFlatTranslationResource('auth', authKo)
          ),
          deepMergeObjects(
            createFlatTranslationResource('actions', actionsKo),
            deepMergeObjects(
              createFlatTranslationResource('common', commonKo),
              createFlatTranslationResource('corporate', corporateKo)
            )
          )
        ),
        createFlatTranslationResource('errors', errorsKo)
      ),
      deepMergeObjects(
        deepMergeObjects(
          createFlatTranslationResource('notifications', notificationsKo),
          createFlatTranslationResource('poster', posterKo)
        ),
        deepMergeObjects(
          deepMergeObjects(
            createFlatTranslationResource('payment', paymentKo),
            createFlatTranslationResource('storage', storageKo)
          ),
          createFlatTranslationResource('time', timeKo)
        )
      )
    ),
  },
  fr: {
    translation: deepMergeObjects(
      deepMergeObjects(
        deepMergeObjects(
          deepMergeObjects(
            billingFr,
            createFlatTranslationResource('auth', authFr)
          ),
          deepMergeObjects(
            createFlatTranslationResource('actions', actionsFr),
            deepMergeObjects(
              createFlatTranslationResource('common', commonFr),
              createFlatTranslationResource('corporate', corporateFr)
            )
          )
        ),
        createFlatTranslationResource('errors', errorsFr)
      ),
      deepMergeObjects(
        deepMergeObjects(
          createFlatTranslationResource('notifications', notificationsFr),
          createFlatTranslationResource('poster', posterFr)
        ),
        deepMergeObjects(
          deepMergeObjects(
            createFlatTranslationResource('payment', paymentFr),
            createFlatTranslationResource('storage', storageFr)
          ),
          createFlatTranslationResource('time', timeFr)
        )
      )
    ),
  },
}

export function mergeTranslationResources(...resourceSets: TranslationResources[]): TranslationResources {
  const merged: TranslationResources = {}

  for (const resourceSet of resourceSets) {
    for (const [language, resource] of Object.entries(resourceSet)) {
      merged[language] ??= { translation: {} }
      merged[language].translation = deepMergeObjects(merged[language].translation, resource.translation)
    }
  }

  return merged
}